import { render, staticRenderFns } from "./AscPlotManagerWrapper.vue?vue&type=template&id=7046d4bb&"
import script from "./AscPlotManagerWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotManagerWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports